import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button } from 'primereact/button';
import VehicleMessageHistoryModal from '../../MessagesView/MessagesViewComponents/VehicleMessageHistoryModal';
import {
  fetchPurchaseInvoice as _fetchPurchaseInvoice,
  enrichPurchaseInvoice as _enrichPurchaseInvoice,
  deletePurchaseInvoice as _deletePurchaseInvoice,
  reincludePurchaseInvoice as _reincludePurchaseInvoice,
  setPurchaseInvoiceHold as _setPurchaseInvoiceHold,
} from '../../../actions/chainActions';

function formatPrice(value) {
  if (value === null || value === undefined) return '-';
  return Number(value).toLocaleString('fi-FI', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }) + ' \u20AC';
}

function formatDate(dateStr) {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('fi-FI');
}

var statusColors = {
  new: { bg: 'rgba(255, 255, 255, 0.1)', color: 'rgba(255, 255, 255, 0.7)', border: 'rgba(255, 255, 255, 0.2)' },
  matched: { bg: 'rgba(100, 181, 246, 0.2)', color: '#90CAF9', border: 'rgba(100, 181, 246, 0.4)' },
  enriched: { bg: 'rgba(129, 199, 132, 0.2)', color: '#A5D6A7', border: 'rgba(129, 199, 132, 0.4)' },
  included: { bg: 'rgba(186, 104, 200, 0.2)', color: '#CE93D8', border: 'rgba(186, 104, 200, 0.4)' },
  excluded: { bg: 'rgba(255, 183, 77, 0.2)', color: '#FFB74D', border: 'rgba(255, 183, 77, 0.4)' },
  error: { bg: 'rgba(229, 115, 115, 0.2)', color: '#EF9A9A', border: 'rgba(229, 115, 115, 0.4)' },
};

function getStatusBadgeStyle(status) {
  var c = statusColors[status] || statusColors.new;
  return {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 600,
    backgroundColor: c.bg,
    color: c.color,
    border: '1px solid ' + c.border,
  };
}

var holdBadgeStyle = getStatusBadgeStyle('excluded');
var creditNoteBadgeStyle = getStatusBadgeStyle('error');

var statusLabels = {
  new: 'piStatusNew',
  matched: 'piStatusMatched',
  enriched: 'piStatusEnriched',
  included: 'piStatusIncluded',
  excluded: 'piStatusExcluded',
  error: 'piStatusError',
};

var itemTypeLabels = {
  work: 'itemTypeWork',
  part: 'itemTypePart',
  other: 'itemTypeOther',
};

class PurchaseInvoiceDetail extends React.Component {
  state = {
    historyModalOpen: false,
  };

  componentDidMount() {
    this.props.fetchPurchaseInvoice(this.props.invoiceId);
  }

  getInvoiceRegNumbers = () => {
    var invoice = this.props.selectedPurchaseInvoice;
    if (!invoice || !invoice.items) return [];
    var seen = {};
    var regs = [];
    invoice.items.forEach(function (item) {
      if (item.vehicle_registration && !seen[item.vehicle_registration]) {
        seen[item.vehicle_registration] = true;
        regs.push(item.vehicle_registration);
      }
    });
    return regs;
  };

  openMessageHistory = () => {
    this.setState({ historyModalOpen: true });
  };

  closeMessageHistory = () => {
    this.setState({ historyModalOpen: false });
  };

  componentDidUpdate(prevProps) {
    if (this.props.invoiceId !== prevProps.invoiceId) {
      this.props.fetchPurchaseInvoice(this.props.invoiceId);
    }
  }

  handleEnrich = function () {
    this.props.enrichPurchaseInvoice(this.props.invoiceId);
  };

  handleReinclude = function () {
    var t = this.props.t;
    if (window.confirm(t('confirmReinclude'))) {
      this.props.reincludePurchaseInvoice(this.props.invoiceId);
    }
  };

  handleToggleHold = function () {
    var t = this.props.t;
    var invoice = this.props.selectedPurchaseInvoice;
    if (!invoice) return;
    if (invoice.invoicing_hold) {
      if (window.confirm(t('confirmClearHold'))) {
        this.props.setPurchaseInvoiceHold(this.props.invoiceId, false, '');
      }
    } else {
      var reason = window.prompt(t('holdReasonPrompt'), '');
      if (reason === null) return;
      this.props.setPurchaseInvoiceHold(this.props.invoiceId, true, reason);
    }
  };

  handleDelete = function () {
    if (window.confirm(this.props.t('confirmDeletePurchaseInvoice'))) {
      this.props.deletePurchaseInvoice(this.props.invoiceId);
      this.props.onClose();
    }
  }.bind(this);

  render() {
    var t = this.props.t;
    var invoice = this.props.selectedPurchaseInvoice;
    var loadStatus = this.props.selectedPurchaseInvoiceStatus;
    var onClose = this.props.onClose;
    var isLoading = loadStatus && loadStatus.loading;

    return (
      <div style={styles.overlay} onClick={onClose}>
        <div style={styles.dialog} onClick={function (e) { e.stopPropagation(); }}>
          {/* Header */}
          <div style={styles.dialogHeader}>
            <h3 style={styles.dialogTitle}>{t('purchaseInvoiceDetail')}</h3>
            <Button
              icon="pi pi-times"
              text
              rounded
              onClick={onClose}
              style={{ color: '#fff', width: 32, height: 32 }}
            />
          </div>

          {isLoading || !invoice ? (
            <div style={styles.loadingContainer}>
              <p style={styles.loadingText}>Ladataan...</p>
            </div>
          ) : (
            <div style={styles.dialogContent}>
              {/* Invoice info */}
              <div style={styles.infoGrid}>
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('invoiceNumber')}</span>
                  <span style={styles.infoValue}>{invoice.invoice_number || '-'}</span>
                </div>
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('workshop')}</span>
                  <span style={styles.infoValue}>{invoice.workshop_name || '-'}</span>
                </div>
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('supplier')}</span>
                  <span style={styles.infoValue}>{invoice.supplier_name || '-'}</span>
                </div>
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('businessId')}</span>
                  <span style={styles.infoValue}>{invoice.supplier_business_id || '-'}</span>
                </div>
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('invoiceDate')}</span>
                  <span style={styles.infoValue}>{formatDate(invoice.invoice_date)}</span>
                </div>
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('dueDate')}</span>
                  <span style={styles.infoValue}>{formatDate(invoice.due_date)}</span>
                </div>
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('amount')} {t('vatInclusive')}</span>
                  <span style={{ ...styles.infoValue, fontWeight: 700, fontSize: 18 }}>
                    {formatPrice(invoice.total_amount)}
                    {Number(invoice.total_amount) < 0 && (
                      <span style={{ ...creditNoteBadgeStyle, marginLeft: 8, verticalAlign: 'middle' }}>
                        {t('creditNote')}
                      </span>
                    )}
                  </span>
                </div>
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('vat')}</span>
                  <span style={styles.infoValue}>{formatPrice(invoice.vat_amount)}</span>
                </div>
                {invoice.reference_number ? (
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('referenceNumber')}</span>
                  <span style={styles.infoValue}>{invoice.reference_number}</span>
                </div>
                ) : null}
                {invoice.your_reference ? (
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('yourReference')}</span>
                  <span style={styles.infoValue}>{invoice.your_reference}</span>
                </div>
                ) : null}
                {invoice.our_reference ? (
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('ourReference')}</span>
                  <span style={styles.infoValue}>{invoice.our_reference}</span>
                </div>
                ) : null}
                {invoice.description ? (
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('freeText')}</span>
                  <span style={styles.infoValue}>{invoice.description}</span>
                </div>
                ) : null}
                {invoice.paid_amount > 0 ? (
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('paidAmount')}</span>
                  <span style={styles.infoValue}>{formatPrice(invoice.paid_amount)}</span>
                </div>
                ) : null}
                {invoice.invoice_status ? (
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('netvisorStatus')}</span>
                  <span style={styles.infoValue}>{invoice.invoice_status}</span>
                </div>
                ) : null}
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('status')}</span>
                  {invoice.status === 'included' && invoice.consolidated_invoice ? (
                    <span
                      style={{ ...getStatusBadgeStyle(invoice.status), cursor: 'pointer', textDecoration: 'underline' }}
                      onClick={function () {
                        this.props.onClose();
                        if (this.props.onOpenConsolidated) {
                          this.props.onOpenConsolidated(invoice.consolidated_invoice);
                        }
                      }.bind(this)}
                    >
                      {t(statusLabels[invoice.status])} #{invoice.consolidated_invoice}
                    </span>
                  ) : (
                    <span style={getStatusBadgeStyle(invoice.status)}>
                      {t(statusLabels[invoice.status] || invoice.status)}
                    </span>
                  )}
                </div>
                {invoice.invoicing_hold && (
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('invoicingHold')}</span>
                  <span>
                    <span style={holdBadgeStyle}>{t('invoicingHold')}</span>
                    {invoice.invoicing_hold_reason ? (
                      <span style={{ ...styles.infoValue, marginLeft: 8 }}>
                        {invoice.invoicing_hold_reason}
                      </span>
                    ) : null}
                  </span>
                </div>
                )}
                <div style={styles.infoItem}>
                  <span style={styles.infoLabel}>{t('afEnriched')}</span>
                  <span style={styles.infoValue}>
                    {invoice.autofutur_enriched ? (
                      <span style={{ color: '#A5D6A7' }}>{'\u2713'} {invoice.autofutur_work_order_number || ''}</span>
                    ) : (
                      <span style={{ color: 'rgba(255,255,255,0.4)' }}>{'\u2717'}</span>
                    )}
                  </span>
                </div>
              </div>

              {/* Enrich action */}
              {!invoice.autofutur_enriched && invoice.membership && (
                <div style={styles.actionRow}>
                  <Button
                    onClick={this.handleEnrich.bind(this)}
                    label={t('enrichFromAutofutur')}
                    icon="pi pi-bolt"
                    size="small"
                    style={styles.enrichButton}
                  />
                </div>
              )}

              {/* Restore a duplicate-quarantined (excluded) invoice to billing */}
              {invoice.status === 'excluded' && (
                <div style={styles.actionRow}>
                  <Button
                    onClick={this.handleReinclude.bind(this)}
                    label={t('reinclude')}
                    icon="pi pi-replay"
                    size="small"
                    style={styles.enrichButton}
                  />
                </div>
              )}

              {/* Manual invoicing hold ("Selvityksessä") toggle */}
              {(invoice.invoicing_hold ||
                (['new', 'matched', 'enriched'].indexOf(invoice.status) !== -1 &&
                  !invoice.consolidated_invoice)) && (
                <div style={styles.actionRow}>
                  <Button
                    onClick={this.handleToggleHold.bind(this)}
                    label={invoice.invoicing_hold ? t('clearInvoicingHold') : t('setInvoicingHold')}
                    icon={invoice.invoicing_hold ? 'pi pi-lock-open' : 'pi pi-pause'}
                    size="small"
                    style={styles.enrichButton}
                  />
                </div>
              )}

              {/* Line items */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h4 style={styles.itemsTitle}>{t('lineItems')}</h4>
                {this.getInvoiceRegNumbers().length > 0 && (
                  <Button
                    onClick={this.openMessageHistory}
                    label={t('viewMessageHistory')}
                    icon="pi pi-comments"
                    size="small"
                    style={styles.enrichButton}
                  />
                )}
              </div>
              <div style={styles.itemsTableContainer}>
                <table style={styles.itemsTable}>
                  <thead>
                    <tr>
                      <th style={styles.itemTh}>#</th>
                      <th style={styles.itemTh}>{t('description')}</th>
                      <th style={styles.itemTh}>{t('type')}</th>
                      <th style={styles.itemTh}>{t('productCode')}</th>
                      <th style={{ ...styles.itemTh, textAlign: 'right' }}>{t('quantity')}</th>
                      <th style={styles.itemTh}>{t('unit')}</th>
                      <th style={{ ...styles.itemTh, textAlign: 'right' }}>{t('unitPrice')} {t('vatInclusive')}</th>
                      <th style={{ ...styles.itemTh, textAlign: 'right' }}>{t('total')} {t('vatInclusive')}</th>
                      <th style={styles.itemTh}>{t('vehicle')}</th>
                      <th style={{ ...styles.itemTh, textAlign: 'center' }}>{t('mekoPart')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice.items && invoice.items.length > 0 ? (
                      invoice.items.map(function (item) {
                        return (
                          <tr key={item.id}>
                            <td style={styles.itemTd}>{item.line_number}</td>
                            <td style={{ ...styles.itemTd, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {item.description || '-'}
                            </td>
                            <td style={styles.itemTd}>{item.item_type ? t(itemTypeLabels[item.item_type] || item.item_type) : '-'}</td>
                            <td style={{ ...styles.itemTd, fontFamily: 'monospace', fontSize: 12 }}>
                              {item.product_code || '-'}
                            </td>
                            <td style={{ ...styles.itemTd, textAlign: 'right' }}>{item.quantity}</td>
                            <td style={styles.itemTd}>{item.unit || '-'}</td>
                            <td style={{ ...styles.itemTd, textAlign: 'right' }}>{formatPrice(item.unit_price)}</td>
                            <td style={{ ...styles.itemTd, textAlign: 'right', fontWeight: 600 }}>
                              {formatPrice(item.total_price)}
                            </td>
                            <td style={styles.itemTd}>{item.vehicle_registration || '-'}</td>
                            <td style={{ ...styles.itemTd, textAlign: 'center' }}>
                              {item.is_meko_part ? (
                                <span style={{ color: '#A5D6A7' }}>{'\u2713'}</span>
                              ) : item.is_meko_part === false ? (
                                <span style={{ color: 'rgba(255,255,255,0.3)' }}>{'\u2717'}</span>
                              ) : '-'}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={10} style={styles.noDataCell}>-</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', marginTop: 8 }}>
                {t('pricesInclVatNote')}
              </p>

              {invoice && !invoice.consolidated_invoice && (
                <div style={{ marginTop: 16, paddingTop: 12, borderTop: '1px solid rgba(255,255,255,0.1)', display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    onClick={this.handleDelete}
                    label={t('deletePurchaseInvoice')}
                    icon="pi pi-trash"
                    size="small"
                    style={{
                      backgroundColor: 'rgba(211, 47, 47, 0.8)',
                      border: 'none',
                      color: '#fff',
                      fontSize: 12,
                      fontWeight: 600,
                    }}
                  />
                </div>
              )}

              {this.state.historyModalOpen && (
                <VehicleMessageHistoryModal
                  modalIsOpen={this.state.historyModalOpen}
                  closeModal={this.closeMessageHistory}
                  registrationNumbers={this.getInvoiceRegNumbers()}
                  referenceDate={invoice.invoice_date}
                  chainId={this.props.selectedChainId}
                  overlayZIndex={1100}
                  title={(invoice.invoice_number || '') + ' · ' + formatDate(invoice.invoice_date)}
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

var styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: 60,
    overflowY: 'auto',
  },
  dialog: {
    backgroundColor: '#0077b0',
    borderRadius: 12,
    border: '1px solid rgba(255, 255, 255, 0.15)',
    width: '90%',
    maxWidth: 1000,
    maxHeight: 'calc(100vh - 100px)',
    overflowY: 'auto',
    marginBottom: 40,
  },
  dialogHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
  },
  dialogTitle: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 600,
    margin: 0,
  },
  dialogContent: {
    padding: '20px 24px',
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: 16,
    marginBottom: 20,
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  infoLabel: {
    color: 'rgba(255, 255, 255, 0.6)',
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  infoValue: {
    color: '#fff',
    fontSize: 14,
  },
  actionRow: {
    marginBottom: 20,
  },
  enrichButton: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.25)',
    color: '#fff',
    fontWeight: 600,
  },
  itemsTitle: {
    color: '#fff',
    fontSize: 15,
    fontWeight: 600,
    margin: '0 0 12px 0',
    paddingTop: 16,
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
  },
  itemsTableContainer: {
    overflowX: 'auto',
  },
  itemsTable: {
    width: '100%',
    borderCollapse: 'collapse',
    whiteSpace: 'nowrap',
  },
  itemTh: {
    padding: '8px 10px',
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
    borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
    textAlign: 'left',
  },
  itemTd: {
    padding: '8px 10px',
    color: '#fff',
    fontSize: 13,
    borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
  },
  noDataCell: {
    padding: '16px',
    color: 'rgba(255, 255, 255, 0.4)',
    textAlign: 'center',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
  loadingText: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: 14,
  },
};

function mapStateToProps(state) {
  return {
    selectedPurchaseInvoice: state.chain.selectedPurchaseInvoice,
    selectedPurchaseInvoiceStatus: state.chain.selectedPurchaseInvoiceStatus,
    selectedChainId: state.chain.selectedChainId,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchPurchaseInvoice: _fetchPurchaseInvoice,
    enrichPurchaseInvoice: _enrichPurchaseInvoice,
    deletePurchaseInvoice: _deletePurchaseInvoice,
    reincludePurchaseInvoice: _reincludePurchaseInvoice,
    setPurchaseInvoiceHold: _setPurchaseInvoiceHold,
  },
)(translate('ChainInvoicingView')(PurchaseInvoiceDetail));
